module.exports = __webpack_public_path__ + "img/portfolio-07-480x343.892c6b4d.jpg";